import { useTheme } from '@mui/system'
import React from 'react'
interface CustomContainerProps {
    children?: React.ReactNode
    disablePadding?: boolean
    customPadding?: string
    disableMarginTop?: boolean
    bgColor?: string
    maxWidth?: string
    disableCentering?: boolean
}
const CustomContainer: React.FC<CustomContainerProps> = ({
    children,
    disablePadding,
    customPadding,
    disableMarginTop,
    bgColor,
    maxWidth,
    disableCentering,
}: CustomContainerProps) => {
    const theme = useTheme()

    return (
        <div
            style={{
                backgroundColor: bgColor ?? theme.palette.customBackground.default,
                margin: disableCentering ? '0' : 'auto',
                marginTop: disableMarginTop ? 0 : theme.spacing(2),
                padding: customPadding ? customPadding : !disablePadding ? theme.spacing(3) : 0,
                maxWidth: maxWidth ?? '1640px',
            }}
        >
            {children}
        </div>
    )
}

export default CustomContainer
